export default __webpack_public_path__ + "static/media/no-internet.585bff17.svg";